import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VisitorTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visit`, {
          page: location.pathname,
          referrer: document.referrer || ''
        });
      } catch (e) {
        // Silently fail
      }
    };
    trackVisit();
  }, [location.pathname]);
  
  return null;
};
